<template>
<div class="container">
    <nav class="add-navigation">
      <div @click="$router.push({name: 'reseller-filters'})"
           class="back-link">
        <svg class="icon"
             width="30px"
             height="30px"
             viewBox="0 0 30 30"
             version="1.1">
          <path d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
                id="path-1">
          </path>
        </svg>
        <p>Back to Filters</p>
      </div>
      <div class="buttons-wrapper">
        <div @click="$router.push({name: 'reseller-filter-list'})"
             class="secondary-button">
          <secondary-button>Cancel</secondary-button>
        </div>
        <div class="primary-button">
          <primary-button @click.native="editFilter">Save Filter</primary-button>
        </div>
      </div>
    </nav>
    <div class="add-container">
        <span class="container-title">Edit Filter</span>
        <div class="col-wrapper">
          <div class="col">
            <primary-input type="text"
                           name="text"
                           class="field"
                           v-model="filter.text"
                           v-validate="'required'"
                           :class="{'input': true, 'is-danger': errors.has('text')}"
                           placeholder="Enter text number" />
            <div class="help is-danger"
                 v-if="errors.has('text')">
              {{ errors.first('text') }}
            </div>
            <div class="help is-danger"
                 v-if="filterError">
              {{filterError.text ? filterError.text[0] : null}}
            </div>
            <div class="list primary-input-container">
              <p class="pimary-input-title">Select Companies</p>
              <multiselect v-model="filter.companies"
                          :options="comapnies"
                          :value="comapnies"
                          :multiple="true"
                          :close-on-select="false"
                          :clear-on-select="false"
                          :preserve-search="true"
                          placeholder="Pick Company"
                          label="company_name"
                          track-by="company_uuid"
                          :preselect-first="true">
                <template slot="selection"
                          slot-scope="{ values, search, isOpen, option }">
                  <span class="multiselect__single"
                        v-if="values.length &amp;&amp; !isOpen">{{ values.length }} numbers selected
                  </span>
                </template>
              </multiselect>
            </div>
             <div class="help is-danger"
                 v-if="errors.has('company')">
              {{ errors.first('company') }}
            </div>
            <div class="help is-danger"
                 v-if="filterError">
              {{filterError.company ? filterError.company[0] : null}}
            </div>
            
          </div>
          <div class="col"> 
              <div class="list primary-input-container">
                <p class="pimary-input-title">Select Vendors</p>
                <multiselect v-model="filter.vendors"
                            :options="vendors"
                            :value="vendors"
                            :multiple="true"
                            :close-on-select="false"
                            :clear-on-select="false"
                            :preserve-search="true"
                            placeholder="Pick Vendors"
                            label="vendor_name"
                            track-by="vendor_uuid"
                            :preselect-first="true">
                    <template slot="selection"
                            slot-scope="{ values, search, isOpen, option }">
                    <span class="multiselect__single"
                            v-if="values.length &amp;&amp; !isOpen">{{ values.length }} numbers selected
                    </span>
                    </template>
                </multiselect>
                </div>
            <div class="help is-danger"
                 v-if="errors.has('vendors')">
              {{ errors.first('vendors') }}
            </div>
            <div class="help is-danger"
                 v-if="filterError">
              {{filterError.vendors ? filterError.vendors[0] : null}}
            </div>
            <primary-select type="text"
                            name="type"
                            class="type"
                            v-validate="'required'"
                            v-model="filter.type"
                            :class="{'input': true, 'is-danger': errors.has('type')}"
                            placeholder="Type">
                <option v-for="(i, k) in type" 
                        :value="i" 
                        :key="k">{{i}}</option>
            </primary-select>
            <div class="help is-danger"
                 v-if="errors.has('type')">
              {{ errors.first('type') }}
            </div>
            <div class="help is-danger"
                 v-if="filterError">
              {{filterError.type ? filterError.type[0] : null}}
            </div>
          </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
  components: {
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    SecondaryButton: () => import('@/components/Buttons/SecondaryButton.vue'),
    PrimaryButton: () => import('@/components/Buttons/PrimaryButton.vue'),
  },
  data: () => ({
    filterError: null,
    type: ['None', 'one or more', 'all clients'],
    // filter: {
    //   text: null,
    //   companies: [],
    //   vendors: [],
    //   type: null,
    // },
    filter: [],
    vendors: [],
    comapnies: [],
  }),
  created() {
      this.getVendorsList();
      this.getCompanyList();
      this.GetFilter();
  },
  methods: {
    GetFilter() {
        this.$store.dispatch('GetFilter', this.$route.params.id ).then(res => {
            console.log("res from GetFilter--->", res);
            this.filter = res //.map(this.transformFilters);
        });
    },
    getVendorsList() {
        this.$store.dispatch("GetVendorList", {
            nice_name: ''
        }).then((res) => {
            this.vendors = res.items
            console.log("res from vendor------->", this.vendors);
        })
    },
    getCompanyList() {
        this.$store.dispatch("GetCompanyList", {}).then((res) => {
            let { total } = res;
            console.log("total--->", total);
            this.$store.dispatch("GetCompanyList", { perPage: total}).then((res) => {
                this.comapnies = res.items;
                console.log("this.companes---->", this.comapnies)
            });
        })
    },
    editFilter() {      
      this.$validator.validate().then(result => {
        if (result) {
          this.filter.companies = this.filter.companies.map( i => {
              return {'company_uuid': i.company_uuid}
          });
          this.filter.vendors = this.filter.vendors.map( i => {
              return {'vendor_uuid': i.vendor_uuid}
          })
          console.log("this.filter", this.filter);
          this.$store
            .dispatch("EditFilter", {
              filter: this.filter,
              id: this.$route.params.id
            })
            .then(() => {
              this.$snotify.success("Filter have been edited.", {
                timeout: 6000
              });
                this.$router.push({ name: "reseller-filters" });
            })
            .catch(err => {
              if (err.errors) {
                this.filterError = err.errors[0].filter
                  ? err.errors[0].filter
                  : null;
                setTimeout(() => {
                  this.filterError = null;
                }, 6000);
              } else {
                this.$snotify.error(err.response.data.errors, {
                  timeout: 6000
                });
              }
            });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.container{
    font-family: "Helvetica Neue";
    padding: 0 20px;
    .add-navigation {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 40px;
        width: 100%;
        margin-top: 20px;
        margin-bottom: 20px;
        .back-link {
        cursor: pointer;
        display: flex;
        align-items: center;
        fill: #51a3f3;
        color: #51a3f3;
        font-family: "Helvetica Neue";
        font-size: 16px;
        font-weight: 500;
        line-height: 20px;
        p {
          margin-bottom: 0;
        }
        }
        .buttons-wrapper {
        display: flex;
        align-items: center;
        width: fit-content;
        .primary-button {
            height: 40px;
            width: 114px;
        }
        .secondary-button {
            height: 40px;
            width: 90px;
            margin-right: 20px;
          }
        }
    }
    .add-container {
        flex-direction: column;
        align-items: center;
        height: 375px;
        background-color: #FFFFFF;
        padding-top: 15px;
        .container-title {
            height: 30px;	
            width: 432px;	
            color: #000000;		
            font-size: 18px;	
            font-weight: 500;	
            line-height: 30px;
            padding: 15px 0 15px 15px;
        }
        .col-wrapper {
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-left: 15px;
            margin-top: 20px;
            .col {
                width: 100%;
                margin-right: 15px;
                padding: 0;
                .input {
                    margin-bottom: 20px;
                }
                .field {
                  p.pimary-input-title {
                    color: #000000;
                    font-family: ""Helvetica Neue"";
                    font-size: 12px;
                    font-weight: 300;
                  }
                }
                .type {
                    margin-top: 20px;
                }
                .pimary-input-title {
                    color: #000000;
                    font-family: ""Helvetica Neue"";
                    font-size: 12px;
                    font-weight: 300;
                    letter-spacing: 0.21px;
                    line-height: 15px;
                    margin-bottom: 5px;
                    text-transform: uppercase;
                }
            }
        }
        .email-input {
            margin-bottom: 20px;
        }
        .password-input {
            margin-bottom: 30px;
        }
        .first {
            margin-bottom: 30px;
            .remember-me {
                display: flex;
                align-items: center;
                input {
                    margin-right: 5px;
                }
            }
        }
    }
}
</style>

